import { defineComponent as v, ref as b, onMounted as h, computed as a } from "vue";
import k from "./component-library260.js";
import P from "./component-library94.js";
import _ from "./component-library6.js";
import I from "./component-library5.js";
import S from "./component-library38.js";
import y from "./component-library261.js";
import T from "./component-library32.js";
import C from "./component-library3.js";
const j = /* @__PURE__ */ v({
  __name: "product-offer-tile",
  props: {
    offerAlternatives: { default: void 0 },
    offerImages: { default: void 0 },
    showAvailableVariant: { type: Boolean },
    tileSize: { default: "s" },
    headingTag: { default: "h2" },
    title: { default: void 0 },
    description: { default: void 0 },
    backgroundImage: { default: void 0 },
    backgroundPosition: { default: void 0 },
    linkTag: { default: "a" },
    hasVoucher: { type: Boolean },
    animateTile: { type: Boolean },
    animationDelay: { default: 1 },
    preTextWasPrice: { default: "statt" },
    noColorTitle: { type: Boolean },
    priceVariant: { default: "small" }
  },
  setup(u, { expose: c }) {
    const e = u, o = k(
      e.offerAlternatives,
      e.offerImages,
      e.showAvailableVariant
    ), r = b(null), s = () => {
      if (!r.value) return;
      const { createScrollTrigger: t, createTweenFrom: i } = P(), g = e.animationDelay || 1;
      t({
        trigger: r.value,
        start: "top bottom",
        end: "top+=25% bottom",
        scrub: 1,
        animation: i(r.value, {
          yPercent: 15 * g
        })
      });
    };
    h(() => {
      s();
    });
    const n = a(() => e.tileSize === "s" ? "size-s" : "size-m"), l = a(() => {
      const i = [`product-offer-tile--${n.value}`];
      return e.backgroundImage && i.push("product-offer--has-background-image"), i.join(" ");
    }), m = a(
      () => o.isHovered.value ? "" : "product-offer-tile__product-image--visible"
    ), d = a(
      () => o.isHovered.value ? "product-offer-tile__product-image--visible" : ""
    ), f = a(() => {
      const t = [];
      return e.backgroundImage && t.push(`--bg-image: url(${e.backgroundImage});`), e.backgroundPosition && t.push(`--bg-position: ${e.backgroundPosition};`), t.join(" ");
    }), p = a(() => e.title || o.activeOffer.value?.product?.name || "");
    return c({
      tileSizeClassModifier: n,
      setBackgroundImageSettings: f,
      isHovered: o.isHovered,
      offerUrl: o.offerUrl.value,
      setHoverState: o.setHoverState,
      componentClass: l
    }), { __sfc: !0, props: e, alternatives: o, componentRef: r, startAnimation: s, tileSizeClassModifier: n, componentClass: l, productImageClass: m, ambientImageClass: d, setBackgroundImageSettings: f, name: p, Heading: _, Paragraph: I, ProductOfferColorSelect: S, ProductOfferShadow: y, Prices: T, LinkButton: C };
  }
});
export {
  j as default
};
